// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ixw0","rightAdornment":"Header_rightAdornment__3zbYl"};